export default __webpack_public_path__ + "static/media/mov.a451e5a8.svg";